import { FC } from 'react';
// import GoogleMapReact from 'google-map-react';

import { Map, Placemark, TypeSelector, YMaps } from '@pbe/react-yandex-maps';

// import DG from '2gis-maps';

export interface MapViewProps {
  lat?: number;
  lng?: number;
  zoom?: number;
  width?: string | number;
  height?: string | number;
  onClick?: any;
}

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

export const MapView: FC<MapViewProps> = ({
  lat = 42.876598,
  lng = 74.606787,
  zoom = 15,
  width = '100%',
  height,
  onClick,
}) => {
  return (
    <YMaps>
      <Map
        defaultState={{ center: [lat, lng], zoom }}
        width={width}
        height={height}
        onClick={onClick}
      >
        <TypeSelector />
        <Placemark geometry={[lat, lng]} />
      </Map>
    </YMaps>
  );
};
